import { cn } from '@/shared/lib/utils';

interface FieldMessageProps {
  children: React.ReactNode;
  variant?: 'helper' | 'error';
  className?: string;
  id?: string;
}

/**
 * Helper / error text shown under a form control.
 */
export function FieldMessage({ children, variant = 'helper', className, id }: FieldMessageProps) {
  return (
    <p
      id={id}
      className={cn(
        'phx-field-msg text-phx-xs leading-snug',
        variant === 'error' ? 'text-phx-danger font-medium' : 'text-phx-text-muted',
        className
      )}
    >
      {children}
    </p>
  );
}
